import React from 'react'
import { Link } from 'gatsby'
import img13 from '../../assets/images/main-banner/banner-two/Innovatiive-Digital-Solution.png'
import icon4 from '../../assets/images/icons/icon4.png'
import icon5 from '../../assets/images/icons/icon5.png'
import icon6 from '../../assets/images/icons/24-7-support-2.png'
import icon7 from '../../assets/images/icons/icon7.png'

const MainBanner = () => {

    return (    
        <React.Fragment>

            <div className="banner-section">


                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                        <div className="banner-content about-content">
                            <div className="content" >
                                <h1>Software Development Company Karachi- Pakistan</h1>
                                <p>Zaavia is a Software Development Company in Karachi, Pakistan, helping businesses solve real-world challenges through reliable technology solutions. Our expertise in HEALTHCARE SOFTWARE improves patient care, simplifies clinical and administrative processes, and increases operational efficiency. Our PRODUCTIVITY TOOLS help businesses improve everyday operations and work more efficiently. We also integrate AI-POWERED BUSINESS AUTOMATION into existing and new workflows to reduce manual work, improve accuracy, and help teams get more done in less time.</p>
                                <Link to="/demo" className="default-btn">
                                    <i className="flaticon-right"></i>
                                    Let's Talk
                                    <span></span>
                                </Link>
                                <ul className="features-list">
                                    <li>
                                        <img src={icon4} alt="banner" />
                                        <p className='banner-features'>12+ Years</p>
                                        On the market
                                    </li>
                                    <li>
                                        <img src={icon5} alt="banner" />
                                        <p className='banner-features'>75+</p>
                                        Clients
                                    </li>
                                    <li>
                                        <img style={{width:'50px'}} src={icon6} alt="banner" />
                                        <p className='banner-features'>24/7</p>
                                        Remote support
                                    </li>
                                    <li>
                                        <img src={icon7} alt="banner" />
                                        <p className='banner-features'>End-to-End</p>
                                        Development 
                                    </li>
                                </ul>
                            </div>
                        </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                        <img src={img13} alt="banner" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default MainBanner
